import React from 'react';
import Modal from './Modal';
import { Clock } from 'lucide-react';

/**
 * Still Interested Modal
 * Shown at 20 minutes to offer 5-minute hold extension
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is visible
 * @param {Function} props.onExtend - Handler when user extends hold
 * @param {Function} props.onRelease - Handler when user releases hold
 * @param {number} props.extensionMinutes - How many minutes the extension provides (default: 5)
 */
export default function StillInterestedModal({
  isOpen,
  onExtend,
  onRelease,
  extensionMinutes = 5
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onRelease}
      title="Still Interested?"
      showCloseButton={false}
      closeOnEscape={false}
      closeOnBackdrop={false}
      footer={
        <>
          <button
            onClick={onRelease}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition"
          >
            Release Hold
          </button>
          <button
            onClick={onExtend}
            className="px-4 py-2 bg-rose-600 hover:bg-rose-700 text-white rounded-lg transition font-semibold"
          >
            Yes, I&apos;m Still Here
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="flex items-center gap-3 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <Clock className="w-5 h-5 text-amber-600 flex-shrink-0" />
          <div className="text-sm text-amber-900">
            Your date hold is about to expire in a few minutes.
          </div>
        </div>

        <div className="text-gray-700">
          <p className="mb-3">
            We&apos;re holding your selected date to make sure it&apos;s available for you, but we can&apos;t hold it forever.
          </p>
          <p className="mb-3">
            If you&apos;re still planning to book this trip, click below to extend your hold for another {extensionMinutes} minutes.
          </p>
          <p className="text-sm text-gray-600">
            If you&apos;re no longer interested, you can release the hold to make the date available for others.
          </p>
        </div>
      </div>
    </Modal>
  );
}
